import React, { FC, useCallback } from 'react';
import { TFunction } from 'react-i18next';
import { MatchButtons } from '../../../../content-composer/src/components/Generic/MatchButtons';

type AcceptRejectPayrollDetailsButtonsProps = {
  isLoading: boolean;
  t: TFunction;
  setAuthAction: React.Dispatch<React.SetStateAction<string | null>>;
  onToggle: () => void;
};

const AcceptRejectPayrollDetailsButtons: FC<AcceptRejectPayrollDetailsButtonsProps> = ({
  isLoading,
  t,
  setAuthAction,
  onToggle,
}) => {
  const onClickLeftBtnHandler = useCallback(() => {
    onToggle();
    setAuthAction('reject');
  }, [onToggle, setAuthAction]);

  const onClickRightBtnHandler = useCallback(() => {
    onToggle();
    setAuthAction('approve');
  }, [onToggle, setAuthAction]);

  return (
    <MatchButtons
      isFullWidth={true}
      leftBtnFullWidth={true}
      onClickLeftBtn={onClickLeftBtnHandler}
      leftBtnLabel={t('acceptRejectPayrollDetailsButtons.leftBtn.label')}
      leftBtnHasSkeleton={isLoading}
      rightBtnFullWidth={true}
      onClickRightBtn={onClickRightBtnHandler}
      rightBtnLabel={t('acceptRejectPayrollDetailsButtons.RightBtn.label')}
      rightBtnHasSkeleton={isLoading}
    />
  );
};

export { AcceptRejectPayrollDetailsButtons };
